module.exports = __webpack_public_path__ + "img/whatsapp-instruction-1.1743e813.png";